import { Component, OnInit } from '@angular/core';
import {CardConditionService} from '../../services/card-condition.service';
import {EditionService} from '../../services/edition.service';
import {ToastrService} from 'ngx-toastr';
import {WarehouseService} from '../../services/warehouse.service';
import {CardService} from '../../services/card.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LanguageService} from '../../services/language.service';
import {Card, Edition, PriceRule, StockRule, StockRulePreference} from '../../core/entities/entities';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {StockRuleAddComponent} from '../stock-rule-add/stock-rule-add.component';
import {StockRuleService} from '../../services/stock-rule.service';

@Component({
  selector: 'app-stock-rule-detail',
  templateUrl: './stock-rule-detail.component.html',
  styleUrls: ['./stock-rule-detail.component.css']
})
export class StockRuleDetailComponent  extends StockRuleAddComponent implements OnInit {

  private origItem : StockRule;
  constructor(_stockRuleService: StockRuleService,
              _route: ActivatedRoute,
              _languageService: LanguageService,
              _warehouseService: WarehouseService,
              _cardConditionService: CardConditionService,
              _cardService: CardService,
              _editionServ: EditionService,
              _router: Router,
              _toastrService: ToastrService) {
    super(_stockRuleService, _route, _languageService, _warehouseService, _cardConditionService, _cardService, _editionServ, _router, _toastrService);
  }

  ngOnInit() {
    super.ngOnInit();
    const me = this;
    this.spinnerService.show();
    this._route.params.subscribe((params) => {
      me._stockRuleService.loadById(params['rule_id'], true).subscribe(ret =>{
        me.origItem = ret;
        me.item = me._stockRuleService.getDTOfromRule(ret);
        me.selectedEditions = me.item.editions;

        this.selectedCards = me.item.cards;
        if(me.item.cardId && me.item.cardId.length > 0){

          me.item.rarityId = [];

        } else if ( ret.editionIdentifier){
          let edition = new Edition();
          edition.id = ret.editionIdentifier;
          edition.name = ret.edition;
          me.selectEdition(new TypeaheadMatch(edition));
        }

        this.spinnerService.hide();

      } );
    });
  }


  remove() {
    this._stockRuleService.remove(this.origItem).subscribe(ret => {this._toastrService.success('Eseguito Correttamente!') ; this._router.navigateByUrl('/home/stock_rules')});
  }

  addPreference() {
    this.item.preferences.push(new StockRulePreference());
  }

  removePreference(prefe: StockRulePreference, index: number) {
    this.item.preferences.splice(index, 1);
  }

  update() {
    this.item.editionId = this.selectedEditions.map( edition => edition.id);
    this.item.categoryId = this.categoryId;
    this.item.brandId = this.brandId;
    this.clear(this.item);
    if(this.item.preferences && this.item.preferences.length > 0) {
      this.item.preferences.forEach( p => this.clear(p));
    }
    this.spinnerService.show();
    this.item.editionId = this.selectedEditions.map( ed => ed.id);
    this._stockRuleService.save(this.item).subscribe(ret => {this._toastrService.success('Eseguito Correttamente!') ; this._router.navigateByUrl('/home/stock_rules')});
  }

}



// WEBPACK FOOTER //
// ./src/app/conf/stock-rule-detail/stock-rule-detail.component.ts